import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils'; // Assuming you have a utility for class names

interface LoadingSpinnerProps {
  className?: string;
}

export const LoadingSpinner = ({ className }: LoadingSpinnerProps) => {
  return <Loader2 className={cn('animate-spin', className)} />;
};
